"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterAction = void 0;
var FooterAction;
(function (FooterAction) {
    FooterAction[FooterAction["SelectAll"] = 0] = "SelectAll";
    FooterAction[FooterAction["SelectNone"] = 1] = "SelectNone";
    FooterAction[FooterAction["Apply"] = 2] = "Apply";
})(FooterAction = exports.FooterAction || (exports.FooterAction = {}));
//# sourceMappingURL=FooterAction.js.map